export default {"src":"/_next/static/media/dialog.9fb0c013.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};